import React, { useRef, useState, useEffect, memo } from 'react';
import Plyr from "plyr-react";

const AudioMediaPlayer = ({ source, setOnload }: any) => {
  const playerRef = useRef<any>(null);
  const [audioBlobURL, setAudioBlobURL] = useState<string>("");
  const [isAudioBlobCreated, setIsAudioBlobCreated] = useState<boolean>(false);

  useEffect(() => {
    const urlToBlob = async () => {
      const blob: any = await fetch(source).then(r => r.blob());
      setAudioBlobURL(URL.createObjectURL(blob));
      setIsAudioBlobCreated(true);
    };
    urlToBlob();
  }, []);

  useEffect(() => {
    if (audioBlobURL !== "" && isAudioBlobCreated) {
      setOnload(false);
    }
  }, [playerRef.current, audioBlobURL, isAudioBlobCreated]);
  
  return (
    <Plyr
      ref={playerRef}
      source={{
        type: "audio",
        sources: [
          {
            src: audioBlobURL
          },
        ]
      }}
    />
  );
};

export default memo(AudioMediaPlayer);
